// extracted by mini-css-extract-plugin
export default {"card":"ChartCard_card__RmZoc","wide":"ChartCard_wide__cKZ4i","title":"ChartCard_title__H8ZSj","body":"ChartCard_body__JTptx"};